import { validateForUI } from 'common/helpers/jsonValidator';

const cancelCreateSchema = {
  type: 'object',
  properties: {
    cancellationReason: { type: 'string' },
    cancellationComments: { type: 'string' }
  },
  required: ['cancellationReason'],
  additionalProperties: false
};

const holdCreateSchema = {
  type: 'object',
  properties: {
    startDate: { type: 'string', format: 'iso-date-time' },
    endDate: { type: 'string', format: 'iso-date-time' },
    holdReason: { type: 'string' },
    holdComments: { type: 'string' }
  },
  required: ['startDate', 'endDate', 'holdReason'],
  additionalProperties: false
};

const holdUpdateSchema = {
  type: 'object',
  properties: {
    startDate: { type: 'string', format: 'iso-date-time' },
    endDate: { type: 'string', format: 'iso-date-time' },
    holdReason: { type: 'string' },
    holdComments: { type: 'string' }
  },
  required: ['endDate', 'holdReason'],
  additionalProperties: false
};

export const validateCancel = (cancel) => {
  const errors = validateForUI(cancelCreateSchema, cancel);
  return errors;
};

export const validateAdd = (hold) => {
  const errors = validateForUI(holdCreateSchema, hold, customValidate(hold));
  return errors;
};

export const validateEdit = (hold) => {
  const errors = validateForUI(holdUpdateSchema, hold, customValidate(hold));
  return errors;
};

const customValidate = (cmh) => {
  const errorArray = [];
  if (cmh.startDate) {
    if (new Date(cmh.startDate) < new Date()) {
      const error = {
        field: 'startDate',
        message: 'Start Date must be greater than now'
      };
      errorArray.push(error);
    }
  }
  if (cmh.startDate && cmh.endDate) {
    if (new Date(cmh.startDate) > new Date(cmh.endDate)) {
      const error = {
        field: 'startDate',
        message: 'Start Date must be less than End Date'
      };
      errorArray.push(error);
    }
  }
  if (cmh.endDate) {
    if (new Date(cmh.endDate) < new Date()) {
      const error = {
        field: 'endDate',
        message: 'End Date must be greater than now'
      };
      errorArray.push(error);
    }
  }
  return errorArray;
};
